import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { CxQuestion } from "./cx-question.entity";

@Entity()
export class CxQuestionOption extends CommonColumns {

  @ManyToOne(() => CxQuestion, cxQuestion => cxQuestion.cxQuestionOptions, { nullable: false, })
  @JoinColumn({ name: 'cx_question_id', referencedColumnName: 'id', })
  cxQuestion: CxQuestion;

  // 敢えて表示名とValueを分けない
  @Column({ name: 'option_text', })
  optionText: string;

  @Column({ name: 'disp_order', })
  dispOrder: number;

  @Column({ name: 'with_free_text', default: false, })
  withFreeText: boolean;

  @Column({ name: 'free_text_placeholder', default: '', })
  freeTextPlaceholder: string;

  @Column({ name: 'free_text_required', default: false, })
  freeTextRequired: boolean;

  constructor(props: TCxQuestionOption) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxQuestionOption = Omit<CxQuestionOption, 'dummy-no-such-field'>;
export interface ICxQuestionOption extends TCxQuestionOption {};
